import theme from '@style';
import {StyleSheet} from 'react-native';
const drawImageWrapPadding = 17;
const drawImageWidth = 236;
const drawImageHeight = 236;
export const needleWidth = 54;
export const needleHeight = 78;
export const ITEM_HEIGHT = 25;
export const titleIcon = require('@assets/imgs/luckyspin/title.png');
export const spinWrapIcon = require('@assets/imgs/luckyspin/spin-wrap.png');
export const turntableIcon = require('@assets/imgs/luckyspin/turntable.webp');

export const needleIcon = require('@assets/imgs/luckyspin/needle.png');
export const copperIcon = require('@assets/imgs/luckyspin/copper.png');
export const pillarIcon = require('@assets/imgs/luckyspin/pillar.webp');
export const footerIcon = require('@assets/imgs/luckyspin/footer.webp');

export const resultIcon = require('@assets/imgs/luckyspin/result.png');
export const moneyIcon = require('@assets/imgs/luckyspin/money.png');
export const buttonGoldenIcon = require('@assets/imgs/luckyspin/button-golden.png');
export const buttonGreenIcon = require('@assets/imgs/luckyspin/button-green.png');
export const vipIcon = require('@assets/imgs/luckyspin/vip.webp');

export const closeIcon = require('@assets/imgs/luckyspin/button-close.png');
export const rotateAudio = require('@assets/imgs/luckyspin/rotate.mp3');
export const openAudio = require('@assets/imgs/luckyspin/open.mp3');
export const styles = StyleSheet.create({
  closeButton: {
    top: -20,
    right: -20,
  },
  drawImageWrap: {
    padding: drawImageWrapPadding,
    paddingTop: drawImageWrapPadding + 2,
    paddingBottom: drawImageWrapPadding - 2,
  },
  needle: {
    top: drawImageHeight / 2 - 50 + drawImageWrapPadding,
    left: (drawImageWidth - needleWidth) / 2 + drawImageWrapPadding,
    zIndex: 1,
  },
  base: {
    bottom: -60,
    left: 4,
    zIndex: -3,
  },
  copper: {
    bottom: 0,
    left: 55,
    zIndex: 3,
  },
  pillar: {
    width: 190,
    height: 45,
    bottom: 0,
    left: 40,
    zIndex: -3,
  },
  footer: {
    zIndex: -4,
    marginTop: -12,
    paddingTop: 34,
    alignItems: 'center',
  },
  result: {
    marginTop: 8,
    paddingTop: 12,
  },
  drawImage: {
    width: drawImageWidth,
    height: drawImageHeight,
    zIndex: -3,
  },
  tabWrap: {
    backgroundColor: '#521a1b',
    borderRadius: theme.borderRadiusSize.xs,
  },
  tabActive: {
    backgroundColor: '#e67053',
    borderRadius: theme.borderRadiusSize.xs,
  },
  nonepadding: {
    paddingVertical: 0,
  },
  tabActiveText: {
    color: theme.basicColor.white,
    paddingHorizontal: 0,
  },
  tabNotActiveText: {
    color: '#e05a5e',
    paddingHorizontal: 0,
  },
  resultList: {
    height: 100,
    marginHorizontal: theme.paddingSize.xl,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  resultItem: {
    height: ITEM_HEIGHT,
  },
  buy: {
    // color: '#43cf7c',
  },
  won: {
    color: '#C90D4A',
  },
});
